import dynamic from 'next/dynamic'

export const DynamicPurchaseConfirmationModal = dynamic(
  () => import('.').then((mod) => mod.PurchaseConfirmationModal),
  { ssr: false },
)
